/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 11:19:48
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 19:00:59
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/tools.ts
 */
import _ from 'lodash';
import React, { useEffect } from 'react';
import { changedStatus, defaultStatus } from 'src/tools/constant';
import {
  useAfterDidMountEffect,
  useDidMountEffect,
} from 'src/tools/customHooks';
import { assData } from 'src/tools/helper';
import { EPreviewSize, WebSiteSubType } from 'src/types/common/SalesChannel';

const generateCollapseOpen = (idArr = []) => {
  return idArr.reduce((pre, now) => {
    return { ...pre, [now]: false };
  }, {});
};

const generateCollapseErrorMsgDisplay = (idArr = [], display?) => {
  return idArr.reduce((pre, now) => {
    return { ...pre, [now]: { hasError: false, display } };
  }, {});
};

const generateCollapse = (idArr, display?) => {
  return {
    collapseOpen: generateCollapseOpen(idArr),
    collapseErrorMsgDisplay: generateCollapseErrorMsgDisplay(idArr, display),
  };
};

const generateDefaultState = (idArr = [], fixedProps?) => ({
  contentUuid: '',
  salesChannelContent: {},
  salesChannelProductUuid: '',
  salesChannelName: '',
  productName: '',
  storeUuid: '1',
  ...generateCollapse(idArr),
  loaded: false,
  uuid: null,
  resetValues: null,
  lastSubmitStamp: null,
  reviewDisplayed: false,
  ...(fixedProps || {}),
});

const convertSpecificError = (specificErr) => {
  const _return = [];
  Object.values(specificErr || {}).forEach((err: string[]) => {
    _return.push(...(err || []));
  });
  return _return;
};

function onCollapseOpen(state, idArr) {
  //   const { idArr = [] } = action.payload; //=>[id:string]
  for (const i in state.collapseOpen) {
    if (idArr.includes(i)) {
      state.collapseOpen[i] = true;
      //state.collapseErrorMsgDisplay[i].display = true;
    } else {
      if (state.collapseOpen[i]) {
        state.collapseOpen[i] = false;
        state.collapseErrorMsgDisplay[i].display = true;
      }
    }
  }
}

function hasError(
  state,
  errSet: { [propsName: string]: { hasError: boolean; display: boolean } },
) {
  state.lastSubmitStamp = JSON.stringify(new Date());
  onCollapseOpen(state, []);
  let isDataValid = true;
  for (const _key of Object.keys(errSet)) {
    const { hasError, display } = errSet[_key];

    if (!display) {
      (state.collapseErrorMsgDisplay[_key] || {}).display = true;
    }

    if (hasError) {
      isDataValid = false;
      //return;
    }

    //state.isDataValid = true;
  }
  state.isDataValid = isDataValid;
}

const useErrorOnChange = (data: {
  err: string[];
  hasError: boolean;
  dispatch;
  action;
  id;
}) => {
  const { err, hasError, dispatch, action, id } = data;
  useEffect(() => {
    if (!hasError && err.length > 0) {
      dispatch(action({ id, status: true }));
    }
    if (hasError && err.length === 0) {
      dispatch(action({ id, status: false }));
    }
  }, [err]);
};

const useErrorOnChange2 = (data: {
  latestHasError: boolean;
  previousHasError: boolean;
  dispatch?;
  action?;
  id;
}) => {
  const { latestHasError, previousHasError, dispatch, action, id } = data;

  useEffect(() => {
    if (action) {
      if (!previousHasError && latestHasError) {
        if (dispatch) {
          dispatch(action({ id, status: true }));
        } else {
          action({ id, status: true });
        }
      }
      if (previousHasError && !latestHasError) {
        if (dispatch) {
          dispatch(action({ id, status: false }));
        } else {
          action({ id, status: false });
        }
      }
    }
  }, [latestHasError, previousHasError]);
};

const errorsCompare = ({
  previousSpecificErrors,
  previousGeneralErrors = [],
  currentSpecificErrors,
  currentGeneralErrors = [],
}) => {
  const returnGeneralError = previousGeneralErrors.filter((i) => {
    return currentGeneralErrors.includes(i);
  });
  // console.log('previousSpecificErrors', previousSpecificErrors);
  // console.log('currentSpecificErrors', currentSpecificErrors);
  const returnSpecificError = Object.keys(previousSpecificErrors).reduce(
    (pre, key) => {
      if (!currentSpecificErrors[key]) {
        return { ...pre, [key]: [] };
      } else {
        const current = previousSpecificErrors[key].filter((i) => {
          return currentSpecificErrors[key].includes(i);
        });

        return { ...pre, [key]: current };
      }
    },
    {},
  );

  return {
    hasError:
      returnGeneralError.length > 0 ||
      convertSpecificError(returnSpecificError).length > 0,
    specificError: returnSpecificError,
    generalError: returnGeneralError,
  };
};
//==================================

const getCurrentDisplayError = ({
  previousError,
  currentData,
  display,
  validation,
  setPDataError,
  isContentGroup,
}) => {
  const {
    hasError: _previousHasError,
    specificError: _previousSpecificError,
    generalError: _previousGeneralError,
  } = previousError;
  const _formatData = isContentGroup
    ? {
        staticData: currentData.staticData,
        dynamicData: currentData.dynamicData,
      }
    : currentData;
  const {
    hasError: currentHasError,
    specificError: _currentSpecificError,
    generalError: _currentGeneralError,
  } = validation //现有的错误
    ? validation(_formatData)
    : { specificError: {}, generalError: [], hasError: false };
  // if (isContentGroup) {
  //   console.log('currentSpecificErrors', _currentSpecificError);
  //   console.log('previousSpecificErrors', _previousSpecificError);
  // }

  const {
    specificError,
    generalError,
    hasError: _currentHasPreviousError,
  } = errorsCompare({
    previousSpecificErrors: _previousSpecificError,
    previousGeneralErrors: _previousGeneralError,
    currentSpecificErrors: _currentSpecificError,
    currentGeneralErrors: _currentGeneralError,
  });
  //console.log('_previousGeneralError', _previousGeneralError);
  // console.log('_currentGeneralError', _currentGeneralError);
  if (
    //可以用comparePError替换
    setPDataError &&
    // comparePError(
    //   {
    //     hasError: _previousHasError,
    //     specificError: _previousSpecificError,
    //     generalError: _previousGeneralError,
    //   },
    //   {
    //     hasError: _currentHasPreviousError,
    //     specificError: _currentSpecificError,
    //     generalError: _currentGeneralError,
    //   },
    // )
    (!_.isEqual(specificError, _previousSpecificError) ||
      !_.isEqual(_.sortBy(_previousGeneralError), _.sortBy(generalError)) ||
      !_.isEqual(_previousHasError, _currentHasPreviousError))
  ) {
    setPDataError({
      specificError,
      generalError,
      hasError: _currentHasPreviousError,
    });
  }

  return {
    currentSpecificError: _currentSpecificError,
    currentGeneralError: _currentGeneralError,
    specificError,
    generalError,
    currentHasPreviousError: _currentHasPreviousError,
    currentHasError,
  };
};
//==================================
const comparePError = (p, c) => {
  const { hasError: pH, specificError: pS, generalError: pG = [] } = p;
  const { hasError: cH, specificError: cS, generalError: cG = [] } = c;

  let hasChanged = false;
  if (pH !== cH) {
    hasChanged = true;
    return hasChanged;
  }

  const gDiff = _.isEqual(pG.sort(), cG.sort()); // _.difference(pG, cG).length > 0;
  if (!gDiff) {
    hasChanged = true;
    return hasChanged;
  }
  const sDiff = () => {
    if (Object.keys(pS).length !== Object.keys(cS).length) {
      return true; //数量不同
    }
    for (const key of Object.keys(pS)) {
      const psD = pS[key] || [];
      const csD = cS[key] || [];
      // console.log('pS[key]', key, pS[key]);
      // console.log('cS[key]', key, cS[key]);
      // console.log('diff', _.isEqual(pS[key].sort(), cS[key].sort()));
      // console.log('test', _.isEqual([], ['Link library cannot be empty']));
      const _diff = _.isEqual(psD.sort(), csD.sort());

      if (_diff) {
        return true;
      }
    }

    return false;
  };

  if (sDiff()) {
    hasChanged = true;
    return hasChanged;
  }
  return hasChanged;
};

const onContentErrorHooks = ({
  data: _data,
  isOpen,
  display: _display,
  validation,
  isContentGroup,
  stamp,
}) => {
  const [pDataError, setPDataError] = React.useState({
    hasError: false,
    specificError: {},
    generalError: [],
  });

  const _formatData = isContentGroup
    ? {
        staticData: _data.staticData,
        dynamicData: _data.dynamicData,
      }
    : _data;
  const _setPDataError = (obj) => {
    setPDataError(obj);
  };

  const moduleType = isContentGroup ? _formatData.staticData.moduleType : null;
  useAfterDidMountEffect(() => {
    setPDataError({
      hasError: false,
      specificError: {},
      generalError: [],
    });
  }, [moduleType]);
  const updateErr = () => {
    const err =
      _display && validation //原有的错误
        ? validation(_formatData)
        : { specificError: {}, generalError: [], hasError: false };

    const isDiff = comparePError(pDataError, err);

    if (isDiff) _setPDataError(err);
  };
  // React.useEffect(() => {
  //   //if (!isOpen)
  //   updateErr();
  // }, [isOpen]);
  useDidMountEffect(() => {
    updateErr();
  }, []);
  useAfterDidMountEffect(() => {
    if (!isOpen) updateErr();
  }, [isOpen]);
  useAfterDidMountEffect(() => {
    updateErr();
  }, [stamp]);

  const {
    currentSpecificError,
    currentGeneralError,
    specificError, //->对应现在应该显示error,对应pDataError里面的数据
    generalError, //->对应现在应该显示error,对应pDataError里面的数据
    currentHasPreviousError, //->对应现在应该显示HasError,对应pDataError里面的数据
    currentHasError,
  } = getCurrentDisplayError({
    previousError: pDataError,
    currentData: _formatData,
    validation,
    display: _display,
    setPDataError: _setPDataError,
    isContentGroup,
  });

  return {
    currentSpecificError,
    currentGeneralError,
    specificError, //->对应现在应该显示error,对应pDataError里面的数据
    generalError, //->对应现在应该显示error,对应pDataError里面的数据
    currentHasPreviousError, //->对应现在应该显示HasError,对应pDataError里面的数据
    currentHasError,
  };
};

const wrapperDataFromServerToRedux =
  (serverData, isPrimary) => (convertFunc) => {
    if (convertFunc)
      return { ...changedStatus, ...convertFunc(serverData || {}, isPrimary) };
    return { ...changedStatus, ...(serverData || {}) };
  };

const isInPCorNative = (currentStyle, currentSize) => {
  return (
    (WebSiteSubType.ResponsivePage === currentStyle &&
      currentSize === EPreviewSize.WIDE) ||
    WebSiteSubType.NativeMobile === currentStyle
  );
};

const isNative = (currentStyle) => {
  return WebSiteSubType.NativeMobile === currentStyle;
};

export {
  hasError,
  assData,
  defaultStatus,
  generateDefaultState,
  onCollapseOpen,
  useErrorOnChange,
  useErrorOnChange2,
  convertSpecificError,
  errorsCompare,
  getCurrentDisplayError,
  onContentErrorHooks,
  generateCollapseOpen,
  generateCollapseErrorMsgDisplay,
  wrapperDataFromServerToRedux,
  generateCollapse,
  isInPCorNative,
  isNative,
};
